import { h } from 'preact';

export default () => (
  <div class='footer'>
    <div>
      Questions or issues? Email <a
        href='mailto:techops@localytics.com'
      >techops@localytics.com</a>
    </div>
    <div>
      Logo made by <a
        href='http://www.freepik.com'
        title='Freepik'
      >Freepik</a> from <a
        href='http://www.flaticon.com'
        title='Flaticon'
      >www.flaticon.com</a> and is licensed by <a
        href='http://creativecommons.org/licenses/by/3.0/'
        title='Creative Commons BY 3.0'
        target='_blank'
      >CC BY 3.0</a>
    </div>
  </div>
);



// WEBPACK FOOTER //
// ./components/footer.js